import React, { useState } from "react";
import { Modal, Box, Button } from "@mui/material";




const formaciones = {
  "4-4-2": [
  { id: 1, tipo: "ARQ", top: "85%", left: "50%" },

  { id: 2, tipo: "LI", top: "65%", left: "15%" },
  { id: 3, tipo: "DF", top: "65%", left: "38%" },
  { id: 4, tipo: "DF", top: "65%", left: "62%" },
  { id: 5, tipo: "LD", top: "65%", left: "85%" },

  { id: 6, tipo: "VI", top: "45%", left: "15%" },
  { id: 7, tipo: "MC", top: "45%", left: "40%" },
  { id: 8, tipo: "MC", top: "45%", left: "60%" },
  { id: 11, tipo: "VD", top: "45%", left: "85%" },

  { id: 9, tipo: "DC", top: "20%", left: "40%" },
  { id: 10, tipo: "DC", top: "20%", left: "60%" },
  ],

  "3-5-2": [
    { id: 1, tipo: "ARQ", top: "85%", left: "50%" },

    { id: 2, tipo: "DF", top: "65%", left: "25%" },
    { id: 3, tipo: "DF", top: "65%", left: "50%" },
    { id: 4, tipo: "DF", top: "65%", left: "75%" },

    { id: 5, tipo: "VI", top: "50%", left: "10%" },
    { id: 6, tipo: "MC", top: "50%", left: "35%" },
    { id: 7, tipo: "MC", top: "50%", left: "50%" },
    { id: 8, tipo: "MC", top: "50%", left: "65%" },
    { id: 9, tipo: "VD", top: "50%", left: "90%" },

    { id: 10, tipo: "DC", top: "20%", left: "40%" },
    { id: 11, tipo: "DC", top: "20%", left: "60%" },
  ],

  "4-3-3": [
    { id: 1, tipo: "ARQ", top: "85%", left: "50%" },

    { id: 2, tipo: "LI", top: "65%", left: "15%" },
    { id: 3, tipo: "DF", top: "65%", left: "38%" },
    { id: 4, tipo: "DF", top: "65%", left: "62%" },
    { id: 5, tipo: "LD", top: "65%", left: "85%" },

    { id: 6, tipo: "MC", top: "45%", left: "30%" },
    { id: 7, tipo: "MC", top: "45%", left: "50%" },
    { id: 8, tipo: "MC", top: "45%", left: "70%" },

    { id: 9, tipo: "DC", top: "20%", left: "20%" },
    { id: 10, tipo: "DC", top: "20%", left: "50%" },
    { id: 11, tipo: "DC", top: "20%", left: "80%" },
  ],
};

export const Cancha = ({ jugadores = [] }) => {
  const [posicionSeleccionada, setPosicionSeleccionada] = useState(null);
  const [alineacion, setAlineacion] = useState({});
  const [open, setOpen] = useState(false);
const [formacion, setFormacion] = useState("4-4-2");



  const abrirModal = (pos) => {
    setPosicionSeleccionada(pos);
    setOpen(true);
  };

  const cerrarModal = () => {
    setOpen(false);
    setPosicionSeleccionada(null);
  };

  const seleccionarJugador = (jugador) => {
    // Asigna jugador
    setAlineacion((prev) => ({
      ...prev,
      [posicionSeleccionada.id]: jugador,
    }));

    // 🔥 Cierra inmediatamente el modal
    cerrarModal();
  };

  const jugadoresFiltrados = jugadores.filter(
    (j) =>
      Array.isArray(j.posicion) &&
      posicionSeleccionada &&
      j.posicion.includes(posicionSeleccionada.tipo)
  );
const posiciones = formaciones[formacion];
  return (
    <>
      <div className="cancha">
        <select className="cancha__formacion"value={formacion} onChange={(e) => setFormacion(e.target.value)}>
          <option value="4-4-2">4-4-2</option>
          <option value="3-5-2">3-5-2</option>
          <option value="4-3-3">4-3-3</option>
        </select>
        {posiciones.map((pos) => {
          const jugadorAsignado = alineacion[pos.id];

          return (
            <div
              key={pos.id}
              className="jugador"
              style={{ top: pos.top, left: pos.left }}
              onClick={() => abrirModal(pos)}
            >
              {jugadorAsignado ? jugadorAsignado.nombre : pos.tipo}
            </div>
          );
        })}
    
      </div>
    <h3 className="nombreEquipo">Las Kabras FC</h3>
      <Modal open={open} onClose={cerrarModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 350,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 3,
          }}
        >
          <h3>Seleccionar {posicionSeleccionada?.tipo}</h3>

          {jugadoresFiltrados.length === 0 && (
            <p>No hay jugadores disponibles</p>
          )}

          {jugadoresFiltrados.map((jugador) => (
            <Button
              key={jugador.id}
              variant="contained"
              fullWidth
              sx={{ mt: 1 }}
              onClick={() => seleccionarJugador(jugador)}
            >
              {jugador.nombre} #{jugador.numero}
            </Button>
          ))}

          <Button
            variant="outlined"
            fullWidth
            sx={{ mt: 2 }}
            onClick={cerrarModal}
          >
            Cancelar
          </Button>
        </Box>
      </Modal>
    </>
  );
};